<template>
  <div
    class="ads-overlay"
    :class="{ 'ads-overlay--clickable': !!adsManager.adClickThrough.value }"
    @click="handleClick"
    @keydown.enter="handleClick"
  >
    <a
      v-if="adsManager.adClickThrough.value"
      class="ads-overlay__learn-more"
      :href="adsManager.adClickThrough.value"
      target="_blank"
      rel="noopener"
      :aria-label="t('player.ads.visitAdvertiser')"
      @click.prevent.stop="adsManager.openAdvertiser()"
    >
      {{ t('player.ads.learnMore') }}
    </a>
  </div>
</template>

<script setup lang="ts">
  import type { UseAdsManagerReturn } from '../../composables/useAdsManager'
  import { useVideoI18n } from '../../i18n'

  const props = defineProps<{
    adsManager: UseAdsManagerReturn
  }>()

  const { t } = useVideoI18n()

  function handleClick(): void {
    if (props.adsManager.adClickThrough.value) {
      props.adsManager.handleAdClick()
    }
  }
</script>

<style scoped lang="scss">
  .ads-overlay {
    position: absolute;
    inset: 0;
    z-index: 10;
    pointer-events: auto;

    &--clickable {
      cursor: pointer;
    }

    &__learn-more {
      position: absolute;
      bottom: 3.5rem;
      left: 1rem;
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
      padding: 0.25rem 0.625rem;
      font-size: 0.8125rem;
      color: #fff;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 4px;
      text-decoration: none;
      transition: background-color 0.15s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.8);
      }

      &:focus-visible {
        outline: 2px solid #fff;
        outline-offset: 2px;
      }
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .ads-overlay__learn-more {
      transition: none;
    }
  }
</style>
